import { useQuery } from "@tanstack/react-query";
import { tarefaService } from "@/services/api/tarefa.service";

/** Busca sob demanda — só chama quando `enabled` (dialog aberto), mesmo gatilho do HistoricoDialog atual. */
export function useTarefaHistorico(tarefaId: number, enabled: boolean) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["tarefa-historicos", tarefaId],
    queryFn: () => tarefaService.getHistoricosByTarefaId(tarefaId),
    enabled: enabled && !!tarefaId,
    staleTime: 1000 * 30,
  });

  return {
    logs: data?.data ?? [],
    total: data?.total ?? 0,
    isLoading,
    isError,
  };
}
